<template>
    <app-layout>
        <div class="flex-1 flex">
            <app-sidebar></app-sidebar>

            <div class="w-full shadow-xl rounded-tl-3xl -mt-5 bg-white px-9 pt-9 flex flex-col">
                <div class="flex space-x-5 items-center mb-8">
                    <div class="text-black text-2xl font-bold">Profile</div>
                    <div class="text-gray-300 text-sm font-medium">/</div>
                    <div class="text-gray-500 text-sm font-medium">Account Details</div>
                </div><!-- Breadcrumbs -->

                <app-errors :form="accountForm" class="mb-10"></app-errors>

                <div v-if="accountForm.successful" class="mb-10">
                    <div class="rounded-md bg-green-50 p-4">
                        <div class="flex">
                            <div class="flex-shrink-0">
                                <svg class="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" /></svg>
                            </div>
                            <div class="ml-3">
                                <p class="text-sm font-medium text-green-800">
                                    Successfully updated
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-3 gap-x-12 gap-y-8">
                    <div class="col-span-1">
                        <h4 class="block text-base font-medium text-gray-500">Email Address</h4>
                        <div class="mt-1 py-1 text-lg"><text-field v-model="accountForm.email" :required="true"></text-field></div>
                    </div>

                    <div class="col-span-1">
                        <h4 class="block text-base font-medium text-gray-500">New Password</h4>
                        <div class="mt-1 py-1 text-lg"><text-field type="password" v-model="accountForm.password" :required="true"></text-field></div>
                        <p class="mt-1 text-xs opacity-70">Keep this blank if you don't want to change your password.</p>
                    </div>

                    <div class="col-span-1">
                        <h4 class="block text-base font-medium text-gray-500">Confirm Password</h4>
                        <div class="mt-1 py-1 text-lg"><text-field type="password" v-model="accountForm.password_confirmation" :required="true"></text-field></div>
                    </div>
                </div>

                <div class="mt-20 sm:flex sm:justify-end">
                    <app-button @click="handleSubmit" :busy="isBusy">Save Changes</app-button>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import AppSidebar from '@/Parts/Sidebar.vue'
import AppButton from '@Components/Button.vue'
import AppErrors from '@Components/Errors.vue'
import TextField from '@Fields/Text.vue'
import useForm from '@/form'
import { ref } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'

export default {
    components: {
        AppLayout,
        AppSidebar,
        AppButton,
        AppErrors,
        TextField
    },
    setup(){
        const pageData = usePage().props.value

        const isBusy = ref(false)

        const accountForm = useForm({
            email: _.get(pageData, 'auth.user.email', ''),
            password: '',
            password_confirmation: ''
        })

        async function handleSubmit(){
            if (!accountForm.isDirty || (accountForm.password_confirmation != '' && accountForm.password == '')) {
                return false
            }

            isBusy.value = true

            await accountForm.post(route('auth.change.credentials')).then(response => {
                if (response.status == 200) {
                    setTimeout(() => {
                        accountForm.reset()
                    }, 2000);
                }
            }).catch(error => {
                console.log(error.response)
            })

            isBusy.value = false
        }

        return {
            isBusy,
            accountForm,
            handleSubmit
        }
    }
}
</script>

<style>

</style>
